import { render, staticRenderFns } from "./ConsultaAfiliadoFallecido.vue?vue&type=template&id=8d853822&scoped=true"
import script from "./ConsultaAfiliadoFallecido.vue?vue&type=script&lang=ts"
export * from "./ConsultaAfiliadoFallecido.vue?vue&type=script&lang=ts"
import style0 from "./ConsultaAfiliadoFallecido.vue?vue&type=style&index=0&id=8d853822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d853822",
  null
  
)

export default component.exports